import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BaseSettingForm } from '../model/form';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { SettingsService } from '../settings.service';
import { firstValueFrom, skipWhile, take } from 'rxjs';
import { NetworkConstants } from 'diwimamodelweb/lib';

@Component({
  selector: 'app-setting-species-form',
  templateUrl: './setting-species-form.component.html',
  styleUrls: ['./setting-species-form.component.css', '../../app.component.scss']
})
export class SettingSpeciesFormComponent implements OnInit {

  @Input() data: BaseSettingForm
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService

  separatorKeysCodes: number[] = [ENTER, COMMA];

  deleteRight = false
  updateRight = false
  nameCtrl = new FormControl()
  ageClassesMaleCtrl = new FormControl()
  ageClassesFemaleCtrl = new FormControl()
  ageClassesUnknownCtrl = new FormControl()
  qualityClassesCtrl = new FormControl()
  ageClassesMale: string[] = []
  ageClassesFemale: string[] = []
  ageClassesUnknown: string[] = []
  qualityClasses: string[] = []

  formInvalid = true
  
  isCreate = false

  constructor(private settingsService: SettingsService) { }

  async ngOnInit(): Promise<void> {
    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
      take(1)
    ))
    const rights = this.settingsService.rightsPercontext.get(context.identifier)
    this.updateRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['U'] ?? false
    this.deleteRight = !rights?.[NetworkConstants.ROUTE_CTX_SETTINGS]?.['D'] ?? false

    if (!this.data.data) this.isCreate = true
    this.ageClassesMale = this.data.data?.ageClassesMale?.de ? this.data.data?.ageClassesMale?.de : []
    this.ageClassesFemale = this.data.data?.ageClassesFemale?.de ? this.data.data?.ageClassesFemale?.de : []
    this.ageClassesUnknown = (this.data.data as any)?.ageClassesUnknown?.de ? (this.data.data as any)?.ageClassesUnknown?.de : []
    this.qualityClasses = this.data.data?.qualityClasses?.de ? this.data.data?.qualityClasses?.de : []

    if (this.data.data) this.nameCtrl.setValue(this.data.data.names.de)

    this.nameCtrl.valueChanges.subscribe((value) => {
      this.setFormValidState()
    })
    this.ageClassesFemaleCtrl.valueChanges.subscribe((value) => {
      this.setFormValidState()
    })
    this.ageClassesMaleCtrl.valueChanges.subscribe((value) => {
      this.setFormValidState()
    })
    this.ageClassesUnknownCtrl.valueChanges.subscribe((value) => {
      this.setFormValidState()
    })
    this.qualityClassesCtrl.valueChanges.subscribe((value) => {
      this.setFormValidState()
    })
  }

  addQualityClass(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.qualityClasses.push(value.trim());
    }

    if (input) {
      input.value = '';
    }
    this.qualityClassesCtrl.setValue(null);
    this.setFormValidState()
  }

  addAgeClassesFemale(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.ageClassesFemale.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
    this.ageClassesFemaleCtrl.setValue(null);
    this.setFormValidState()
  }

  addAgeClassesMale(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.ageClassesMale.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
    this.ageClassesMaleCtrl.setValue(null);
    this.setFormValidState()
  }

  addAgeClassesUnknown(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.ageClassesUnknown.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
    this.ageClassesUnknownCtrl.setValue(null);
    this.setFormValidState()
  }

  removeMaleAgeClass(data: string) {
    const ind = this.ageClassesMale.findIndex(el => el == data)
    if (ind >= 0) {
      this.ageClassesMale.splice(ind, 1);
    }
    this.setFormValidState()
  }

  removeFemaleAgeClass(data) {
    const ind = this.ageClassesFemale.findIndex(el => el == data)
    if (ind >= 0) {
      this.ageClassesFemale.splice(ind, 1);
    }
    this.setFormValidState()
  }

  removeUnknownAgeClass(data) {
    const ind = this.ageClassesUnknown.findIndex(el => el == data)
    if (ind >= 0) {
      this.ageClassesUnknown.splice(ind, 1);
    }
    this.setFormValidState()
  }

  removeQualityClass(data) {
    const ind = this.qualityClasses?.findIndex(el => el == data)
    if (ind >= 0) {
      this.qualityClasses.splice(ind, 1);
    }
    this.setFormValidState()
  }

  setFormValidState() {
    const name = this.nameCtrl.value
    if (!name) this.formInvalid = true
    else {
      this.formInvalid = false
    }
  }

  onSubmit() {
    if (this.nameCtrl.value == undefined) return 
    const name = this.nameCtrl.value
    if (this.isCreate) {
      const species = {
        identifier: name,
        names:{de: name},
        ageClassesFemale: {de: this.ageClassesFemale},
        ageClassesMale: {de: this.ageClassesMale},
        ageClassesUnknown: {de: this.ageClassesUnknown},
        qualityClasses: {de: this.qualityClasses}
      }
      const cleaned = removeUndefined(species)
      this.data.onCreate(cleaned)
    } else {
      this.data.data.names.de = name
      this.data.data.ageClassesFemale.de = this.ageClassesFemale
      this.data.data.ageClassesMale.de = this.ageClassesMale;
      (this.data.data as any).ageClassesUnknown = { de: this.ageClassesUnknown }
      if( this.data.data.qualityClasses )
        this.data.data.qualityClasses.de = this.qualityClasses
      else
        this.data.data.qualityClasses = {de: this.qualityClasses}

      this.data.onSubmit()
    }
  }

  onDelete(){
    this.data.onDelete(this.data)
  }
}
